import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "tv_dich_vu_am_thuc";

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    return ApiService(api);
};


export default moduleApi;